<template>
  <div id="dongnanxibeiluzhu">
    <div class="tr-header">
      <p class="title">东南西北路珠</p>
      <div class="dayHandles">
        <DatePick @onchange="onchangeDate"></DatePick>
      </div>
    </div>
    <div class="tr-header-container">
      <div class="handle-con">
        <div class="title">
          <span>筛选号码</span>
          <div class="handles" style="display:inline-block;padding-left:20px">
            <CheckboxGroup v-model="selectBalls">
              <Checkbox
                v-if="betType == 'hpten'"
                :label="it.key"
                v-for="(it,i) in balls"
                :key="i"
              >号码{{i + 1}}</Checkbox>
              <!-- <Checkbox :label="it.key" v-for="(it,i) in balls" :key="i">{{it.name}}</Checkbox> -->
            </CheckboxGroup>
          </div>
          <span class="select_span" @click="allSelect">全选</span>
          <span class="select_span" @click="selectBalls = []">清空</span>
        </div>
      </div>
    </div>
    <div class="tr-table-container">
      <Road
        v-for="(it,i) in dataSource"
        :data="it"
        :betType="betType"
        :key="i"
        v-if="~selectBalls.indexOf(Object.keys(it)[0])"
      ></Road>
      <!-- <Road v-for="(it,i) in roadsData" :data="it" :key="i" v-if="~selectBalls.indexOf(i)"></Road> -->
    </div>
  </div>
</template>

<script>
import DatePick from "../components/DatePick";
import dayjs from "dayjs";
import statistic from "../../../helpers/statistic";
import Road from "./Road";
import format from "../../../helpers/format.js";

function setBall(start, len) {
  let res = [];
  for (let i = start; i <= len; i++) {
    res.push({
      name: `号码${i}`,
      key: `ball${i}`
    });
  }
  return res;
}
export default {
  name: "dongnanxibeiluzhu",
  components: {
    DatePick,
    Road
  },
  data() {
    return {
      selectDay: dayjs(new Date()).format("YYYY-MM-DD"),
      dataSource: [],
      balls: [],
      selectBalls: []
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    },
    roadsData() {
      return statistic.getBallRoads(this.betType, this.dataSource);
    }
  },
  created() {
    this.reset();
  },
  methods: {
    allSelect() {
      // this.selectBalls = ["num0", "num1", "num2", "num3", "num4", "num5"];
      // this.balls.map(x => x.key);
      this.selectBalls = this.balls.map(x => x.key);
    },
    onchangeDate(date) {
      this.selectDay = dayjs(date).format("YYYY-MM-DD");
      this.getData();
    },
    reset() {
      if (this.betType == "hpten") {
        this.balls = setBall(1, 8);
        this.selectBalls = this.balls.map(x => x.key);
        // console.log(this.selectBalls, "this.selectBalls");
      }
    },
    init() {
      // this.reset();
      this.getData();
    },
    async getData() {
      let res = await this.$http.post("/queryKcDateReport.do", {
        gameType: this.$route.params.gameType,
        date: this.selectDay
      });
      if (res.data.returnCode == "0000") {
        let arr = format.formatJson(res.data.returnList);

        if (arr.length > 0) {
          var a = this.formatList(arr[0].ball_dewdrop_json);
          this.dataSource = a;
        }
        // console.log(this.dataSource, "this.dataSource");
        // this.dataSource = res.data.returnList;
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatList(obj) {
      var keys = Object.keys(obj);
      var arr = [];
      for (let i = 0; i < keys.length; i++) {
        var o = {};
        const e = keys[i];
        o[e] = obj[e].position;
        if (this.selectBalls.includes(e)) {
          var n = parseInt(e.slice(-1));
          arr[n - 1] = o;
          // arr.push(o);
        }
      }

      return arr;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>




// WEBPACK FOOTER //
// src/pages/Trend/dongnanxibeiluzhu/index.vue